import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const CAP_LABELS = {
  push: "Push", pull: "Pull", squat: "Squat", bend_lift: "Bend & Lift",
  rotation: "Rotation", endurance: "Endurance", mobility_control: "Mobility / Control",
};

export const AGE_RANGES = ["18-29", "30-44", "45-59", "60+"];

export const EQUIPMENT_LIST = [
  { id: "bodyweight", label: "Bodyweight" },
  { id: "dumbbells", label: "Dumbbells" },
  { id: "kettlebell", label: "Kettlebell" },
  { id: "bands", label: "Resistance Bands" },
  { id: "plates", label: "Weight Plates" },
  { id: "med_ball", label: "Medicine Ball" },
  { id: "slam_ball", label: "Slam Ball" },
  { id: "agility_ladder", label: "Agility Ladder" },
  { id: "cones", label: "Cones" },
  { id: "box", label: "Box / Step" },
];

export const BODY_PARTS = [
  { id: "knees", label: "Knees" },
  { id: "lower_back", label: "Lower Back" },
  { id: "shoulders", label: "Shoulders" },
  { id: "hips", label: "Hips" },
  { id: "wrists", label: "Wrists" },
  { id: "ankles", label: "Ankles" },
  { id: "neck", label: "Neck" },
];

export const SCORE_CATEGORIES = [
  { min: 90, label: "EXCEPTIONAL EVERYDAY CAPABILITY" },
  { min: 75, label: "HIGHLY CAPABLE" },
  { min: 60, label: "MOVING WELL" },
  { min: 40, label: "DEVELOPING CAPABILITY" },
  { min: 0, label: "BUILD YOUR FOUNDATION" },
];

export const categoryFor = (s) => SCORE_CATEGORIES.find((c) => s >= c.min).label;

export function fmtErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
}
